import { useTranslation } from 'react-i18next';

import { Box, Button, Menu } from '@valwin/facto/components';
import { CheckIcon } from '@valwin/facto/icons';

import type { SupportedLanguage } from '~shared/i18n';

type LanguageLabels = Record<SupportedLanguage, string>;

const getLanguageLabelShort = (langCode: string): string => {
  const labels: LanguageLabels = {
    fr: 'Fr',
    es: 'Es',
  };

  return labels[langCode as SupportedLanguage] || langCode.toUpperCase();
};

const getLanguageLabel = (langCode: string): string => {
  const labels: LanguageLabels = {
    fr: 'Français',
    es: 'Español',
  };

  return labels[langCode as SupportedLanguage] || langCode.toUpperCase();
};

const getLanguageFlag = (langCode: string): string => {
  const flags: LanguageLabels = {
    fr: '🇫🇷',
    es: '🇪🇸',
  };

  return flags[langCode as SupportedLanguage] || '🌐';
};

export function LanguageSelector() {
  const { i18n } = useTranslation();

  const changeLanguage = (language: SupportedLanguage) => {
    i18n.changeLanguage(language);
  };

  const currentLanguage = i18n.language;
  const allSupported = i18n.options.supportedLngs || [];
  const supportedLanguages = allSupported.filter((lng) => lng !== 'cimode');

  const handleLanguageChange = (langCode: string) => () => {
    changeLanguage(langCode as SupportedLanguage);
  };

  return (
    <Box>
      <Menu positioning={{ placement: 'bottom-end' }}>
        <Menu.Trigger asChild>
          <Button size="sm" variant="ghost" colorPalette="gray">
            <Box as="span" lineHeight="0">
              {getLanguageFlag(currentLanguage)}
            </Box>
            <Box as="span" lineHeight="0" fontWeight="500">
              {getLanguageLabelShort(currentLanguage)}
            </Box>
          </Button>
        </Menu.Trigger>

        <Menu.Content>
          {supportedLanguages.map((lang) => (
            <Menu.Item
              key={lang}
              value={lang}
              onClick={handleLanguageChange(lang)}
              cursor="pointer"
            >
              <span>{getLanguageFlag(lang)}</span>
              <span>{getLanguageLabel(lang)}</span>
              {lang === currentLanguage && <CheckIcon size="sm" />}
            </Menu.Item>
          ))}
        </Menu.Content>
      </Menu>
    </Box>
  );
}
